const url =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_NODE_BACKEND_PROD
    : process.env.VUE_APP_NODE_BACKEND_DEV

export const WS_SERVER =
  process.env.NODE_ENV === 'production' ? `wss://${url}` : `ws://${url}`
export const NODE_SERVER =
  process.env.NODE_ENV === 'production' ? `https://${url}` : `http://${url}`
